var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_984_12115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1.30029V6.68369",
    stroke: "#EF4444",
    strokeWidth: 1.26935,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2336 2.90016C12.3598 3.63313 13.219 4.71041 13.6831 5.97144C14.1473 7.23246 14.1915 8.60971 13.8092 9.89792C13.4269 11.1861 12.6386 12.3163 11.5617 13.12C10.4849 13.9237 9.1771 14.358 7.83337 14.3579C6.48964 14.3579 5.18188 13.9237 4.10501 13.12C3.02815 12.3163 2.23983 11.1861 1.85755 9.89789C1.47527 8.60968 1.5195 7.23243 1.98365 5.97141C2.4478 4.71039 3.30701 3.63311 4.43323 2.90015",
    stroke: "#EF4444",
    strokeWidth: 1.04,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_984_12115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.500244)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/Power.3a4bae2a3fe8ae6262adf404a6c54a69.svg";
export { ForwardRef as ReactComponent };